module.exports = "<div class=\"m-grid__item m-grid__item--fluid m-wrapper\">\r\n    <router-outlet></router-outlet>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/pages/academias/academias.component.html
// module id = ./src/app/theme/pages/academias/academias.component.html
// module chunks = main